import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ShareOptionsComponent } from './share-options.component';

@NgModule({
  declarations: [ShareOptionsComponent],
  imports: [CommonModule, IonicModule],
  exports: [ShareOptionsComponent],
})
export class ShareOptionsModule {}

